import {
	PortalInvite,
	PortalInvitee,
	PortalInviteStatus,
} from '@models/portal-invites';

export class CreatePortalInvite {
	static readonly type = '[portal-invite] create portal invite';
	constructor(public payload: { portalInvite: PortalInvite }) {}
}

export class AddInvitees {
	static readonly type = '[portal-invite] add invitees to portal invite';
	constructor(
		public payload: {
			inviteId: string;
			invitees: PortalInvitee[];
		},
	) {}
}

export class RemoveInvitees {
	static readonly type = '[portal-invite] remove invitees from portal invite';
	constructor(
		public payload: {
			inviteId: string;
			invitees: PortalInvitee[];
		},
	) {}
}

export class UpdateInviteeEmail {
	static readonly type = '[portal-invite] update invitee email';
	constructor(
		public payload: {
			inviteId: string;
			newEmail: string;
			clientId: string;
		},
	) {}
}

export class UpdateStatus {
	static readonly type = '[portal-invite] update status';
	constructor(
		public payload: {
			inviteId: string;
			status: PortalInviteStatus;
			updatedBy: string;
		},
	) {}
}

export class UpdatePortalInvite {
	static readonly type = '[portal-invite] update portal invite';
	constructor(
		public payload: {
			inviteId: string;
			portalInvite: Partial<PortalInvite>;
			updatedBy: string;
		},
	) {}
}

export class DeactivatePortalInvite {
	static readonly type = '[portal-invite] deactivate portal invite';
	constructor(
		public payload: {
			inviteId: string;
			updatedBy: string;
		},
	) {}
}
